/**
 * Store Switcher for Korres DACH
 * Handles cross-domain country/store switching with persistence
 */
(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    console.log('Store Switcher: Initializing...');
    
    const storeSwitches = document.querySelectorAll('.js-store-switch');
    
    console.log('Store Switcher: Found', storeSwitches.length, 'store switch elements');
    
    if (storeSwitches.length === 0) {
      console.warn('Store Switcher: No .js-store-switch elements found!');
      return;
    }

    const defaultSelectedCountriesByDomain = {
      'korres.ch': 'switzerland',
      'de.korres.com': 'germany',
      'korres-dach.myshopify.com': 'germany'
    };

    // Parse URL parameters
    const urlParams = new URLSearchParams(location.search);
    const selectedCountryByUrl = urlParams.get('selectedcountry');
    const wasPopupShownBeforeURLParameter = urlParams.get('waspopupshownbefore');

    // Set popup shown flag from URL
    if (wasPopupShownBeforeURLParameter) {
      localStorage.setItem('wasPopupShownBefore', 'true');
    }

    const wasPopupShownBefore = localStorage.getItem('wasPopupShownBefore') === 'true';

    // Initialize selected country
    if (selectedCountryByUrl) {
      localStorage.setItem('lastSelectedCountry', selectedCountryByUrl);
    } else if (!localStorage.getItem('lastSelectedCountry')) {
      const defaultCountry = defaultSelectedCountriesByDomain[location.hostname];
      if (defaultCountry) {
        localStorage.setItem('lastSelectedCountry', defaultCountry);
      }
    }

    /**
     * Activate the switch popup
     */
    function activateSwitchPopup() {
      const switchPopup = document.querySelector('.js-switch-popup');
      console.log('Store Switcher: Activating popup', switchPopup);
      if (switchPopup) {
        switchPopup.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    }

    /**
     * Close the switch popup
     */
    function closeSwitchPopup() {
      const switchPopup = document.querySelector('.js-switch-popup');
      if (switchPopup) {
        switchPopup.classList.remove('is-active');
        document.body.style.removeProperty('overflow');
      }
    }

    /**
     * Apply popup shown parameter to URL
     */
    function applyShownPopupParameterToUrl(url) {
      if (!url) return url;
      
      const urlObj = new URL(url);
      urlObj.searchParams.set('waspopupshownbefore', 'true');
      return urlObj.href;
    }

    /**
     * Get country info from element
     */
    function getCountryInfo(countryElement) {
      const linkElement = countryElement.querySelector('a');
      return {
        name: countryElement.getAttribute('data-title'),
        link: linkElement ? linkElement.getAttribute('href') : null,
        domain: linkElement ? linkElement.getAttribute('data-domain') : null
      };
    }

    /**
     * Change all country selectors to match selected country
     */
    function changeAllCountrySelectors(countryName) {
      if (!countryName) return;

      storeSwitches.forEach(storeSwitch => {
        const currentItem = storeSwitch.querySelector('.country__item.current');
        if (currentItem) {
          currentItem.classList.remove('current');
        }

        const newCurrentItem = storeSwitch.querySelector(`.country__item[data-title="${countryName}"]`);
        if (newCurrentItem) {
          newCurrentItem.classList.add('current');
        }

        // Update the flag in the trigger - copy from the country item
        const flagContainer = storeSwitch.querySelector('.js-store-switch-image');
        if (flagContainer && newCurrentItem) {
          const countryFlag = newCurrentItem.querySelector('img');
          if (countryFlag) {
            flagContainer.innerHTML = countryFlag.outerHTML;
          }
          flagContainer.className = `js-store-switch-image store-switch__flag store-switch__flag--${countryName}`;
        }

        // Update text element
        const textElement = storeSwitch.querySelector('.js-store-switch-text');
        if (textElement) {
          switch (countryName) {
            case 'switzerland':
              textElement.textContent = 'CH';
              break;
            case 'austria':
              textElement.textContent = 'AT';
              break;
            default:
              textElement.textContent = 'DE';
          }
        }
      });
    }

    /**
     * Handle store switching logic
     */
    function handleStoreSwitcher(clickedCountry) {
      const clickedInfo = getCountryInfo(clickedCountry);
      const currentCountryItem = clickedCountry.closest('.country-selector__body').querySelector('.current');
      const currentInfo = currentCountryItem ? getCountryInfo(currentCountryItem) : { name: null, domain: null };

      console.log('Store Switcher: Switching from', currentInfo.name, 'to', clickedInfo.name);

      // Same country selected
      if (currentInfo.name === clickedInfo.name) {

        localStorage.setItem('lastSelectedCountry', clickedInfo.name);
        changeAllCountrySelectors(clickedInfo.name);
        return;
      }

      // Same domain (e.g., Germany -> Austria)
    

      // Different domain - need to redirect
      if (wasPopupShownBefore) {
        localStorage.setItem('lastSelectedCountry', clickedInfo.name);
        changeAllCountrySelectors(clickedInfo.name);
        
        const newUrl = applyShownPopupParameterToUrl(clickedInfo.link);
        const newUrlObj = new URL(newUrl);
        newUrlObj.pathname = location.pathname;
        
        location.href = newUrlObj.href;
      } else {
        const newUrl = applyShownPopupParameterToUrl(clickedInfo.link);
    
        activateSwitchPopup();
        
        const acceptBtn = document.querySelector('.js-switch-popup .js-accept');
        if (acceptBtn) {
          acceptBtn.setAttribute('data-link', newUrl);
        }
      }
    }

    /**
     * Select country on page load based on localStorage
     */
    function selectCountryOnLoad(storeSwitch) {
      const storedCountryName = localStorage.getItem('lastSelectedCountry');
      if (!storedCountryName) return;

      const currentItem = storeSwitch.querySelector('.country__item.current');
      const storedCountryItem = storeSwitch.querySelector(`.country__item[data-title="${storedCountryName}"]`);
      
      if (currentItem && storedCountryItem && currentItem !== storedCountryItem) {
        currentItem.classList.remove('current');
        storedCountryItem.classList.add('current');
      }

      changeAllCountrySelectors(storedCountryName);
    }

    /**
     * Close all dropdowns
     */
    function closeAllDropdowns() {
      storeSwitches.forEach(sw => {
        sw.classList.remove('visible');
      });
    }

    // Initialize each store switch
    storeSwitches.forEach((storeSwitch, index) => {
      console.log('Store Switcher: Setting up switch', index, storeSwitch.getAttribute('data-type'));
      
      // Set initial country on load
      selectCountryOnLoad(storeSwitch);

      // Get elements
      const flagTrigger = storeSwitch.querySelector('.js-store-switch-image');
      const countrySelector = storeSwitch.querySelector('.country-selector');
      
      console.log('Store Switcher: Flag trigger found:', !!flagTrigger);
      console.log('Store Switcher: Country selector found:', !!countrySelector);

      // Toggle dropdown when clicking the flag/trigger area
      storeSwitch.addEventListener('click', function(event) {
        console.log('Store Switcher: Click detected on', event.target);
        
        // If clicking inside the country selector dropdown, don't toggle
        if (event.target.closest('.country-selector')) {
          console.log('Store Switcher: Click was inside dropdown, not toggling');
          return;
        }
        
        // If clicking on background overlay, don't toggle (let the background handler deal with it)
        if (event.target.classList.contains('country-selector-background')) {
          return;
        }

        event.stopPropagation(); // Prevent document click from immediately closing
        
        // Close other dropdowns first
        storeSwitches.forEach(sw => {
          if (sw !== storeSwitch) {
            sw.classList.remove('visible');
          }
        });
        
        // Toggle this dropdown
        const isVisible = this.classList.toggle('visible');
        console.log('Store Switcher: Dropdown visibility toggled to', isVisible);
      });

      // Handle country item clicks
      const countryItems = storeSwitch.querySelectorAll('.country__item');
      countryItems.forEach(countryItem => {
        countryItem.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          
          console.log('Store Switcher: Country item clicked', this.getAttribute('data-title'));
          
          handleStoreSwitcher(this);
          closeAllDropdowns();
        });
      });

      // Mobile specific: close on background click
      const background = storeSwitch.querySelector('.country-selector-background');
      if (background) {
        background.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          storeSwitch.classList.remove('visible');
        });
      }

      // Mobile specific: close button
      const closeBtn = storeSwitch.querySelector('.js-country-selector-mobile-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          storeSwitch.classList.remove('visible');
        });
      }
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.js-store-switch')) {
        closeAllDropdowns();
      }
    });

    // Popup event handlers
    document.addEventListener('click', function(event) {
      const popup = event.target.closest('.js-switch-popup');
      if (!popup) return;

      // Accept button
      if (event.target.classList.contains('js-accept')) {
        const link = event.target.getAttribute('data-link');
        if (link) {
          closeSwitchPopup();
          const newUrl = new URL(link);
          newUrl.pathname = location.pathname;
          location.href = newUrl.href;
        }
      }

      // Close button
      if (event.target.classList.contains('js-close') || event.target.closest('.js-close')) {
        closeSwitchPopup();
      }
    });

    // Close popup on overlay click
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('store-switch-popup__overlay')) {
        closeSwitchPopup();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeSwitchPopup();
        closeAllDropdowns();
      }
    });

    console.log('Store Switcher: Initialization complete');
  }
})();